if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
      }

      setActiveMedia(mediaId) {
        const targetMedia = this.getMediaById(mediaId);
        if (!targetMedia) return;

        const targetSlide = targetMedia.closest('.swiper-slide');
        if (!targetSlide) {
          targetMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
          return;
        }

        const swiperComponent = targetSlide.closest('swiper-component');
        const swiper = this.getSwiperInstance(swiperComponent);
        const slideIndex = this.getSlideIndex(targetSlide, swiperComponent, swiper);
        const activeThumbnailIndex = this.getLogicalSlideIndex(targetSlide, slideIndex);

        if (swiper && slideIndex > -1) {
          if (typeof swiper.slideToLoop === 'function' && targetSlide.dataset.swiperSlideIndex) {
            swiper.slideToLoop(activeThumbnailIndex);
          } else if (typeof swiper.slideTo === 'function') {
            swiper.slideTo(slideIndex);
          }

          swiper.update?.();
          this.updateThumbnails(swiperComponent, activeThumbnailIndex);
          return;
        }

        targetSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        this.updateThumbnails(swiperComponent, activeThumbnailIndex);
      }

      getMediaById(mediaId) {
        const requestedMediaId = this.normalizeMediaId(mediaId);

        return Array.from(this.querySelectorAll('[data-media-id]')).find((media) => {
          const currentMediaId = this.normalizeMediaId(media.dataset.mediaId);

          return currentMediaId === requestedMediaId || media.dataset.mediaId === String(mediaId);
        });
      }

      normalizeMediaId(mediaId) {
        return String(mediaId).split('-').pop();
      }

      getSwiperInstance(swiperComponent) {
        if (!swiperComponent) return null;

        return (
          swiperComponent.initSwiper ||
          swiperComponent.querySelector('.swiper-main')?.swiper ||
          swiperComponent.querySelector('.swiper')?.swiper ||
          null
        );
      }

      getSlideIndex(targetSlide, swiperComponent, swiper) {
        const swiperSlides = swiper?.slides ? Array.from(swiper.slides) : [];
        const swiperIndex = swiperSlides.indexOf(targetSlide);

        if (swiperIndex > -1) return swiperIndex;

        const slides = Array.from(swiperComponent?.querySelector('.swiper-main .swiper-wrapper')?.children || []);

        return slides.indexOf(targetSlide);
      }

      getLogicalSlideIndex(targetSlide, fallbackIndex) {
        const logicalIndex = Number(targetSlide.dataset.swiperSlideIndex);

        return Number.isNaN(logicalIndex) ? fallbackIndex : logicalIndex;
      }

      updateThumbnails(swiperComponent, activeIndex) {
        if (!swiperComponent || activeIndex < 0) return;

        swiperComponent.querySelectorAll('.swiper-controls__thumbnail').forEach((button, index) => {
          const isActive = index === activeIndex;

          button.classList.toggle('active', isActive);
          button.toggleAttribute('aria-selected', isActive);
        });
      }
    }
  );
}
